export class ListWithinList{
    hasSubList:boolean;
    listWithinListList = new Array<ListWithinList>();
    text: string;
}


// WEBPACK FOOTER //
// /workspace/backend-server/src/app/core/models/list-within-list.ts